module.exports = __webpack_public_path__ + "img/icon-google.109a9688.svg";